import { z } from 'zod'

export const FormSchema = z.object({
  justification: z.string().min(1, 'Justification is required when rejecting'),
})

export type DecisionFormData = z.infer<typeof FormSchema>

export type AcceptRejectProviderItemParams = {
  providerId: number
  itemId: number
  programId: number
  status: 1 | 2
  justification?: string
}
